'use strict';

(function ($) {

    $.Toolbar = function (element) {
        var plugin = this;
        var element = element;

        plugin.Enable = function (key, enable) {
            var btn = element.data('viewModel').getButton(key);

            if (btn)
                btn.disabled = !enable;
        }

        plugin.Remove = function (key) {
            var vm = element.data('viewModel');
            var btn = vm.getButton(key);

            if (btn)
                vm.buttons.remove(vm.getButton(key));
        }
    }

    // add the plugin to the jQuery.fn object
    $.fn.Toolbar = function (options) {
        if (undefined == $(this).data('Toolbar'))
        {
            var plugin = new $.Toolbar(this, options);
            $(this).data('Toolbar', plugin);
            return plugin;
        }
        else
        {
            return $(this).data('Toolbar');
        }
    }

})(jQuery);